<template>
  <v-btn :color="color" @click="toggleSidebar" flat>
    <v-icon>filter_list</v-icon>
    <span class="ml-2">Filtros</span>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["showFiltersSidebar"]),
    color() {
      return this.showFiltersSidebar ? "blue" : "black";
    }
  },
  methods: {
    ...mapMutations(["setShowFiltersSidebar"]),
    toggleSidebar() {
      this.setShowFiltersSidebar(!this.showFiltersSidebar);
    }
  }
};
</script>